import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=af369fb0&scoped=true"
import script from "./StatusBadge.vue?vue&type=script&lang=js"
export * from "./StatusBadge.vue?vue&type=script&lang=js"
import style0 from "./StatusBadge.vue?vue&type=style&index=0&id=af369fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af369fb0",
  null
  
)

export default component.exports